import { combineReducers } from "redux";
import { permissionReducer } from "./permissionReducer";
import { toastReducer } from "./toastReducer";
import { userReducer } from "./userReducer";

const rootReducer = combineReducers({
  user: userReducer,
  toast: toastReducer,
  permissions: permissionReducer
});

export default rootReducer;
